<div fxLayout="row" fxLayoutAlign="start start" class="login-page">
  <div fxFlex.lt-md="100" fxFlex="50" fxLayoutAlign="center center" class="login-left">
    <div class="login-container">
      <h1 class="title">Login</h1>
      <p>Insira os seus dados de usuário abaixo</p>
      <form [formGroup]="loginForm" class="login-form" style="margin-bottom: 30px;">
        <mat-form-field style="width: 100%;" appearance="outline" class="login-input">
          <mat-label>E-mail</mat-label>
          <input
            matInput
            formControlName="email"
            placeholder="contato@contato.com">
          <mat-hint>Informe um email!</mat-hint>
        </mat-form-field>

        <mat-form-field style="width: 100%;" appearance="outline" class="login-input">
          <mat-label>Senha</mat-label>
          <input
            matInput
            type="password"
            formControlName="passwd"
            placeholder="Senha Válida">
          <mat-hint>Informe uma senha!</mat-hint>
        </mat-form-field>

        <p *ngIf="_error" style="color: red;">Erro ao fazer login, tente novamente.</p>

        <button
          [disabled]="_loading"
          mat-raised-button
          color="primary"
          class="login-btn"
          (click)="makeLogin()"
        >
          <span *ngIf="_loading; else elseBlock"><mat-spinner diameter="30"></mat-spinner></span>
          <ng-template #elseBlock><span ngElse>Fazer Login</span></ng-template>
        </button>
      </form>

      <mat-divider></mat-divider>

      <div style="margin-top: 30px;">
        <h5 style="margin: 0; margin-bottom: 5px;">Caso você ainda não seja registrado,</h5>
        <h4
          (click)="openCallWithoutRegister()"
          class="text-hard-green clickable"
          style="margin: 0;"
        >{{ 'clique aqui para abrir um chamado.' | uppercase }}</h4>
      </div>
    </div>

  </div>

  <div fxHide.lt-md fxFlex="50" class="login-right">
    <div class="login-right-colorized" fxLayoutAlign="end start">
      <h1 class="title text-white login-right-title">MHelp</h1>
    </div>
    <div>
      <img class="login-right-img" src="assets/img/login-img-client.png" alt="MSys" height="50">
    </div>
  </div>
</div>
